import type { PeopleRoster, TeamMember } from "@don/wire";

import type { AddForm } from "./add.js";

/**
 * Edit's rules, as arithmetic (epic 26-10-02-knowledge-v0, issue 216; ux-spec decision 20,
 * design-spec §5 `edit-form`, §6). Edit is the Add form prefilled, so the field messages, when
 * Save is enabled and what is sent are `add.ts`'s (`addFormMessages`, `addFormValid`,
 * `addRequest`). What differs is here; `edit.test.ts` asserts each.
 */

/** The dialog's title (design-spec §6 "Form"): the full name as the row shows it. */
export function editTitle(member: TeamMember): string {
  return `Edit ${member.display_name}`;
}

/**
 * The form prefilled from the row. A NULL email or a `null` jurisdiction (a legacy row, issue
 * 212) opens blank, so Save stays disabled until it is filled (`addFormValid`).
 */
export function editForm(member: TeamMember): AddForm {
  return {
    name: member.display_name,
    email: member.email ?? "",
    worksIn: member.jurisdiction ?? "",
    touched: { name: false, email: false },
    onTeam: null,
  };
}

/** The in-dialog Notice when a save fails (design-spec §6 "Save failed (chosen)"). */
export function editFailedCopy(member: TeamMember): string {
  return `Couldn't save ${member.display_name}. Nothing was changed. Try again.`;
}

/**
 * The roster once the server has saved an edit: the person's row replaced by the server's,
 * where `orderRoster` places it by its (perhaps new) name. A person no longer on the roster is
 * not added back.
 */
export function withEdited(roster: PeopleRoster, person: TeamMember): PeopleRoster {
  return { people: roster.people.map((m) => (m.person_id === person.person_id ? person : m)) };
}
